import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../../context/ThemeContext';

export default function VideoCard({ session, fullWidth = false }) {
  const navigate = useNavigate();
  const { isDark } = useTheme();
  const speakerInitial = session.speaker?.charAt(0) || '?';

  return (
    <div
      onClick={() => navigate(`/app/entrenamientos/${session.id}`)}
      className={`group cursor-pointer ${fullWidth ? 'w-full' : 'flex-none w-72 md:w-96'}`}
    >
      <div className="relative aspect-video rounded-2xl overflow-hidden bg-[var(--bg-surface)] shadow-md transition-all duration-300 group-hover:shadow-xl group-hover:-translate-y-1 border border-[var(--border-subtle)]">
        <img
          src={session.thumbnail}
          alt={session.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className={`absolute inset-0 ${isDark ? 'bg-brand-night/20' : 'bg-brand-navy/10'} group-hover:bg-transparent transition-colors`} />

        {/* Play Icon */}
        <div className="absolute top-4 left-4 z-10">
          <div className="w-10 h-10 gfi-gradient-bg rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity transform scale-75 group-hover:scale-100 duration-300">
            <SafeIcon name="Play" className="w-4 h-4 text-brand-navy fill-current ml-0.5" />
          </div>
        </div>

        {/* Bottom gradient + title/instructor overlay */}
        <div className="absolute inset-x-0 bottom-0 z-[1] pt-16 pb-10 px-3 bg-gradient-to-t from-black/85 via-black/55 to-transparent pointer-events-none">
          <h3 className="font-black text-white text-sm md:text-lg line-clamp-2 leading-tight uppercase italic tracking-tight drop-shadow-sm">
            {session.title}
          </h3>
          {session.speaker && (
            <div className="flex items-center gap-2 mt-1.5">
              <div className="w-5 h-5 rounded-full gfi-gradient-bg p-[1px] shrink-0">
                <div className="w-full h-full rounded-full bg-black/40 flex items-center justify-center text-[8px] font-black text-white">
                  {speakerInitial}
                </div>
              </div>
              <p className="text-[10px] font-bold text-white/85 uppercase tracking-widest truncate">
                {session.speaker}
              </p>
            </div>
          )}
        </div>

        {/* Duration / category badges — same bottom-left placement on thumbnail */}
        <div className="absolute bottom-3 left-3 z-[2] flex gap-1.5">
          <span className="px-2 py-0.5 bg-brand-navy text-brand-cream text-[9px] font-black uppercase tracking-tighter rounded">
            {session.duration}
          </span>
          <span className="px-2 py-0.5 bg-[var(--bg-surface)] text-[var(--text-main)] text-[9px] font-black uppercase tracking-tighter rounded border border-[var(--border-subtle)]">
            {session.category}
          </span>
        </div>
      </div>
    </div>
  );
}
